// @flow
import React from 'react';
import styled, { withTheme } from 'styled-components';
import { translate } from 'react-i18next';

import { Card } from 'statsradio/themes/v3/Stylesheet';
import type { DateRange } from 'statsradio/domain/reach';
import type { ComparedMetric } from 'statsradio/modules/dashboard/domain/DashboardData';
import MetricsDateRange from './MetricsDateRange';
import ReachMetrics from './ReachMetrics';

const Container = styled.div`
  display: flex;
`;

const Spacer = styled.div`
  min-width: ${({ theme }) => theme.V3.metrics.margin.normal}px;
`;

const MetricsCard = styled(Card)`
  margin-bottom: ${({ theme }) => theme.V3.metrics.margin.normal}px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const SMetricsDateRange = styled(MetricsDateRange)`
  padding-top: 20px;
  padding-left: 30px;
`;

interface Props {
  dateRange: DateRange;
  comparedDateRange: DateRange;
  cumulativeReach: ComparedMetric;
  averageQuarterHourReach: ComparedMetric;

  t: any;
  theme: any;
}

function ComparedMetricsOverview({ dateRange, comparedDateRange, cumulativeReach, averageQuarterHourReach, t, theme }: Props) {
  return (
    <Container>
      <MetricsCard>
        <SMetricsDateRange dateRange={dateRange} />
        <ReachMetrics cumulativeReach={cumulativeReach} averageQuarterHourReach={averageQuarterHourReach} />
      </MetricsCard>

      <Spacer />

      <MetricsCard>
        <SMetricsDateRange dateRange={comparedDateRange} />
        <ReachMetrics cumulativeReach={cumulativeReach.compared} averageQuarterHourReach={averageQuarterHourReach.compared} />
      </MetricsCard>
    </Container>
  );
}

export default translate('metrics')(withTheme(ComparedMetricsOverview));



// WEBPACK FOOTER //
// ./src/statsradio/modules/metrics/v2/components/reachMetricsOverview/ComparedMetricsOverview.js